// hooks/useCampaigns.ts

type GetCampaignsParams = {
  page?: number;
  page_size?: number;
  sort_order?: string;
  campaign_name?: string;
};
import { getCampaigns } from "@/services/rest/campaign-service";
import { useQuery } from "@tanstack/react-query";

export const useGetCampaigns = (
  params?: GetCampaignsParams,
  isLogin?: boolean
) => {
  return useQuery({
    queryKey: ["campaigns", params],
    queryFn: () => getCampaigns(params ?? {}),
    enabled: isLogin,
  });
};
